import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { parseExperiments } from './parsing';
import type { QueryClient } from '@tanstack/react-query';

const loadExperiencesFromWindow = () => {
  return parseExperiments({
    convertData: window.convert?.currentData || window.convert?.data,
  });
};

export const loadExperiencesQuery = queryOptions({
  queryKey: ['experiences'],
  queryFn: loadExperiencesFromWindow,
  staleTime: Infinity,
});

export const useExperiences = () => {
  return useSuspenseQuery(loadExperiencesQuery);
};

export const getLatestExperiences = () => {
  return loadExperiencesFromWindow();
};

export const updateExperiencesCache = (queryClient: QueryClient) => {
  const freshData = loadExperiencesFromWindow();
  queryClient.setQueryData(loadExperiencesQuery.queryKey, freshData);
};
